// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.remove-button[data-v-a0ce4bb2]{\n    -webkit-box-flex: 0;\n            flex-grow: 0;\n}\n.remove-button .btn i[data-v-a0ce4bb2]{\n    width: auto;\n}\n", ""]);
// Exports
module.exports = exports;
